import { useApi } from '~/composables/useApi';

/**
 * PA 대시보드 API
 * - 타입이 명시된 파라미터 사용
 * - URLSearchParams를 통한 데이터 전송
 */
export function usePaDashboardApi() {
  return {
    /**
     * 대시보드 데이터 조회 (전체 데이터 한번에 조회)
     * @param year - 조회 년도
     * @param month - 조회 월
     */
    fetchDashboardData: (year: string, month: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      return useApi('/api/pa/dashboard/getDashboardData.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 연도별 성과 추이 데이터 조회
     * @param year - 조회 년도
     * @param month - 조회 월
     */
    fetchYearlyPerformanceTrend: (year: string, month: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      return useApi('/api/pa/dashboard/getYearlyPerformanceTrend.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 조직별 관리자 성과 목록 조회
     * @param year - 조회 년도
     * @param month - 조회 월
     * @param jigGbnCd - 직급구분코드 (01:팀장, 02:부서장, 03:본부장)
     */
    fetchManagerPerformanceList: (year: string, month: string, jigGbnCd: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      params.append('jigGbnCd', jigGbnCd);
      return useApi('/api/pa/dashboard/getManagerPerformanceList.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 구성원 성과 상세 데이터 조회 (모달용 - 최근 5개년도)
     * @param userId - 구성원 ID
     * @param year - 기준 년도
     * @param month - 기준 월
     */
    fetchMemberPerformanceDetail: (userId: string, year: string, month: string) => {
      const params = new URLSearchParams();
      params.append('userId', userId);
      params.append('year', year);
      params.append('month', month);
      return useApi('/api/pa/dashboard/getMemberPerformanceDetail.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 전체 구성원 데이터셋 조회 (모달용)
     * @param year - 조회 년도
     * @param month - 조회 월
     */
    fetchAllMemberDataset: (year: string, month: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      return useApi('/api/pa/dashboard/getAllMemberFocusScoreList.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },
  };
}
